/**
 * 添加单个部门
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IAddInput {
    parent_department_id: string;
    department_name: string;
}
export interface IAddOutput {
    status: number;
    desc: string;
}
export const addDepartment = (data: IAddInput) => {
    return fetchData(Api.ADD_DEPARTMENT, data).then((res: IResponse<IAddOutput>) => {
        return res.data;
    });
};
